export default "__VITE_ASSET__4e6a79d8__$_?nuxt_component=async__"